/**
 * Created by mac on 12/8/20
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    TITLE_COLOR_YELLOW: new cc.Color(134, 56, 10, 255),
    TITLE_SHADOW: new cc.Color(255, 251, 126, 255)
});

cleverapps.styles.DECORATORS = cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    WHITE_TEXT_STROKE: {
        color: cleverapps.styles.COLORS.BLACK,
        size: 2
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    PACKWINDOW_LABEL_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_TIMER_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_PROGRESS_IMAGE_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_TICKET_TEXT: {
        size: 35,
        color: new cc.Color(139, 81, 42)
    },

    PASS_TICKET_SMALL_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    PASS_REWARD_TEXT: {
        size: 56,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    PASS_PROGRESS_POINT: {
        size: 40,
        color: new cc.Color(144, 189, 210)
    },
    COLLECTION_BADGE_TEXT: {
        name: "default",
        size: 20,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    INGREDIENT_ORDER_ICON_TEXT: {
        size: 58
    },

    TOOLTIP_REWARDS_FONT: {
        name: "default",
        size: 41,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },

    SINGLE_PRODUCT_OFFER_REWARD: {
        name: "nostroke"
    },

    DARK_PACK_BUTTON_TEXT: {
        color: new cc.Color(164, 72, 64, 255)
    }
});

cleverapps.overrideStyles(cleverapps.styles.InfoView, {
    button: {
        type: {
            default: cleverapps.styles.UI.Button.Images.small_button_green,
            secondary: cleverapps.styles.UI.Button.Images.small_button_blue
        }
    }
});

cleverapps.styles.InfoViewAbTest = cleverapps.overrideStyles(cleverapps.styles.InfoView, {
    bar: {
        mainType: ScaledProgressBar.Types.blue_sections_with_frames,
        noText: true,
        width: 175,
        padding: {
            top: 14,
            bottom: 2
        }
    }
}, true);

cleverapps.overrideStyles(cleverapps.styles.GiftContentView, {
    width: 640,
    minHeight: 160
});

cleverapps.overrideStyles(cleverapps.styles.UI.CheckBox, {
    label: {
        offsetY: -8
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassTicket, {
    margin: 0,

    free: {
        text: 235,
        x: { align: "center", dx: 15 },
        y: { align: "center", dy: 19 },
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    },

    premium: {
        x: { align: "center", dx: 15 },
        y: { align: "bottom", dy: 19 },
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassHeader, {
    decor: {
        x: { align: "center", dx: -600 }
    },

    pack: {
        x: { align: "right", dx: 15 },
        y: { align: "center", dy: 5 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassProgress, {
    tasks: {
        height: 580
    }
});

cleverapps.overrideStyles(cleverapps.styles.ExpeditionPassHeader, {
    title: {
        x: { align: "center" },
        y: { align: "top", dy: -60 }
    },
    amount: {
        x: { align: "center" },
        y: { align: "center", dy: -80 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ExpeditionPassWindow, {
    height: 836,

    header: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 27 }
    },

    progress: {
        x: { align: "right", dx: 2 },
        y: { align: "bottom", dy: -40 }
    },

    tickets: {
        x: { align: "left", dx: -2 },
        y: { align: "center", dy: -104 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SceneComponent, {
    clearColor: new cc.Color(52, 150, 205, 255)
});

cleverapps.overrideStyles(cleverapps.styles.ThirdElementWindow, {
    infoBlock: {
        timer: {
            x: { align: "left", dx: 50 },
            y: { align: "center", dy: 10 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent, {
    pack: {
        offsetY: 205,
        offsetX: 300,
        title: {
            x: { align: "center", dx: 220 },
            y: { align: "center", dy: -90 },
            width: 200
        }
    },
    tap: {
        x: { align: "left", dx: -380 },
        y: { align: "center", dy: 410 },
        zIndex: 3
    }
});

cleverapps.overrideStyles(cleverapps.styles.DeleteAccountWindow, {
    person: "worker"
});

cleverapps.overrideStyles(cleverapps.styles.SubscriptionWindow, {
    width: 1200,
    margin: 45
});

cleverapps.overrideStyles(cleverapps.styles.DialogueViewVertical, {
    colorTypes: {
        hero: 1,
        dwarf: 1,
        king: 0,
        narrator: 0,
        worker: 0,
        bear: 1,
        elf: 3,
        hunter: 7,
        seller: 2,
        troll: 4,
        warlock: 6,
        bard: 3,
        centaur: 4,
        fish: 3,
        gnomes: 5,
        keeper: 7,
        knight: 3,
        magician: 6,
        miner: 5,
        panda: 2,
        priestess: 7,
        rpcentaur: 4,
        rpgnomes: 5,
        shark: 6
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialogueViewVertical, {
    noStageImage: true
});

cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.EXPEDITION], {
    badges: [
        {
            x: { align: "center", dx: 737 },
            y: { align: "center", dy: -268 },
            largeFont: true
        }
    ],

    rewards: {
        unit: {
            dragonpack: {
                x: { align: "center", dx: -533 },
                y: { align: "center", dy: -397 }
            }
        },
        hard: {
            x: { align: "center", dx: 577 },
            y: { align: "center", dy: -377 },
            rotation: -1
        }
    }
});
cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.DRAGONIA2], {
    badges: [
        {
            x: { align: "center", dx: 737 },
            y: { align: "center", dy: -268 },
            largeFont: true
        }
    ],

    rewards: {
        unit: {
            dr2dragonpack: {
                x: { align: "center", dx: -533 },
                y: { align: "center", dy: -397 }
            }
        },
        hard: {
            x: { align: "center", dx: 577 },
            y: { align: "center", dy: -377 },
            rotation: -1
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    sparksColors: {
        GoldItem: "purple",
        LivesItem: "blue",
        CoinsItem: "yellow",
        default: "white"
    }
});

cleverapps.overrideStyles(cleverapps.styles.WorkerView, {
    buildingAnimation: false,

    timer: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -48 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.WorkerComponentTimer, {
    withoutBar: true,

    button: {
        width: 110
    }
});

cleverapps.overrideStyles(cleverapps.styles.ComponentTimer, {
    timer: {
        width: 140
    }
});

cleverapps.overrideStyles(cleverapps.styles.InstantWorkerView, {
    jump: {
        repeat: false
    }
});

cleverapps.overrideStyles(cleverapps.styles.IngredientOrderIcon, {
    icon: {
        scale: 1.5
    }
});

cleverapps.styles.MineableViewAbTest = cleverapps.overrideStyles(cleverapps.styles.MineableView, {
    progress: {
        type: ScaledProgressBar.Types.blue_sections_with_frames_small
    }
}, true);

cleverapps.overrideStyles(cleverapps.styles.DialogueViewHorizontal, {
    showAnimation: "fromBelow",

    image: {
        padding: 70
    }
});

cleverapps.overrideStyles(cleverapps.styles.UpgradableView, {
    progress: {
        text: {
            position: { y: { dy: 0 } }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.FogBlockView, {
    opener: {
        text: {
            y: { dy: 2 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.SALEPASS], {
    person: {
        role: "seller"
    }
});

cleverapps.overrideStyles(cleverapps.styles.SingleProductOfferWindow[Offers.TYPES.BUILDPASS], {
    rewards: {
        font: cleverapps.styles.FONTS.SINGLE_PRODUCT_OFFER_SALE_REWARD,
        unit: {
            bppointsstar: {
                x: { align: "center", dx: -138 },
                y: { align: "center", dy: -329 }
            },
            crystal: {
                x: { align: "center", dx: 222 },
                y: { align: "center", dy: -328 }
            }
        }
    }
});

if (cleverapps.styles.CustomerIngredientViewInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.CustomerIngredientViewInfoView, {
        bg: {
            width: 90,
            height: 76,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 1 }
        }
    });
    cleverapps.overrideStyles(cleverapps.styles.CustomerIngredientViewInfoViewLarger, {
        bg: {
            width: 118,
            height: 92,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 1 }
        }
    });
}
